export default __webpack_public_path__ + "masa-tenisi.svg";